import React from 'react';
import styled from 'styled-components';
import CheckboxBase from '@mui/material/Checkbox';
import { DateRange } from '@mui/icons-material';

import { HALF_CONTRAST } from '../theme';

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding-bottom: 6px;
`;

const CheckboxLabel = styled.div`
  color: ${HALF_CONTRAST};
  font-size: 14px;
`;

const noop = () => { };

export const Checkbox = ({
 label, checked, id, timeline, onClick = noop,
}) => (
    <CheckboxWrapper onClick={() => onClick(id, !checked)}>
      <CheckboxBase checked={checked} />
      {
        timeline ? (
          <DateRange
            style={{
              paddingRight: 6,
              cursor: 'pointer',
              color: '#6e6e6e',
              fontSize: 14,
            }}
          />
        ) : null
      }
      <CheckboxLabel>{label}</CheckboxLabel>
    </CheckboxWrapper>
  );
